// @ts-check

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';
import { HeaderGroupManager } from './header-group';

// @ts-expect-error Alpine is a global
window.Alpine = Alpine;
Alpine.store('settings', {
  // @ts-expect-error BRANCHNAME is a global
  branchName: BRANCHNAME,
  // @ts-expect-error GITUSER is a global
  gitUser: GITUSER,
  isProd: process.env.NODE_ENV === 'production'
});
Alpine.store('headerGroupManager', HeaderGroupManager.getInstance());

// TODO: Move this into PDP JS
Alpine.data('pdpDialog', () => ({
  selectedIndex: 0,
  showPdpDialog: false,
  /**
   * open dialog and set selected index
   * @param {Event} $event
   */
  openDialog($event) {
    this.showPdpDialog = true;
    const target = $event.target;
    if (!(target instanceof HTMLElement)) return;
    const pdpImageWrapper = target.closest('.pdp-image-wrapper');
    if (pdpImageWrapper instanceof HTMLElement) {
      this.selectedIndex = parseInt(pdpImageWrapper.dataset.index || '0', 10);
    }
    const pdpMedia = target.closest('.product__media');
    if (!pdpMedia) return;
    const dialog = pdpMedia.querySelector('dialog');
    if (!dialog) return;
    dialog.showModal();
    this.$nextTick(() => this.$refs.modalClose?.focus());
    document.body.classList.add('overflow-hidden');
    this.scrollMediaIntoView(dialog);
  },
  /**
   * scroll the selected media element into view
   * @param {HTMLDialogElement} element
   */
  scrollMediaIntoView(element) {
    const selectedElement = element.querySelectorAll('[data-dialog-media]')[this.selectedIndex];
    this.$nextTick(() => {
      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center'
        });
      }
    });
  }
}));
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.start();